import React, { useRef } from "react";
import { CircularProgress } from "@mui/material";

const ColorChange = ({ color, setColor, setChangedColor, submit, loading }) => {
  const colorRef = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    submit();
    window.localStorage.setItem("theme", color);
    setChangedColor(color);
  };

  return (
    <div className="Theme_Wrapper">
      <div className="bottomContain">
        <div className="Row_Wrap">
          <div className="Input_Contain">
            <label htmlFor="first_name">Customize your dashboard look</label>
            <input
              type="color"
              className="Color_palette"
              value={color}
              ref={colorRef}
              onChange={(e) => {
                setColor(e.target.value);
              }}
            />
            <div
              className="Color_palette_display"
              style={{
                borderColor: color ? color : "#13ABF4",
                overflowX: "hidden",
              }}
              onClick={() => colorRef.current.click()}
            >
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  backgroundColor: color ? color + "1F" : "#13ABF41F",
                }}
              ></div>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  backgroundColor: color ? color : "#13ABF4",
                }}
              ></div>
            </div>
          </div>
          <div className="Input_Contain"></div>
        </div>
        <div className="Btn_wrap">
          <button
            onClick={(e) => {
              color !== "" && handleSubmit(e);
            }}
          >
            {loading === false ? (
              "Change Theme"
            ) : (
              <CircularProgress color="inherit" size={14} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColorChange;
